export const ORDER_SHEET_KEY_MAP = {
  id: '엑셀 행 순번',
  source: '데이터 출처',
  outgoingFileName: '출고서 파일명',
  movementType: '이동 상태',
  orderSheetType: '주문서 양식',
  orderId: '주문서 번호',
  relativerProductId: '연동상품ID',
  orderName: '주문명',
  outgoingProductName: '출고상품명',
  outgoingProductCode: '출고상품코드',
  outgoingProductId: '출고상품',
  orderCount: '주문수량',
  orderUnit: '주문단위',
  outgoingProductCount: '출고수량',
  outgoingContainerName: '출고창고명',
  outOfStockYype: '재고부족여부',
  changeCount: '수량변경',
  outgoingProductCancel: '출고취소(상품)',
  orderInfoId: '주문정보ID',
  outgoingOrderCancled: '출고취소(주문)',
  ordererName: '주문자',
  ordererPhone: '주문자전화번호',
  receiverName: '수취인',
  receiverPhone1: '수취인전화번호1',
  receiverPhone2: '수취인전화번호2',
  receiverAddress1: '수취인주소1',
  receiverAddress2: '수취인주소2',
  memo: '메모',
  courier: '택배사명',
};
